import { Alert, AlertTitle, Card, CardContent, CardHeader, FormControlLabel, FormLabel, Grid, Grid2, Radio, RadioGroup } from "@mui/material";

function DataKesehatan({ handleChange, data }) {
    return (<>
        <Card>
            <CardHeader title="Data Kesehatan Calon Santri" sx={{ borderBottom: "1px solid #f4f4f4" }}>
            </CardHeader>
            <CardContent>
                <Alert variant="filled" severity="warning">
                    <AlertTitle>
                        Perhatian!
                    </AlertTitle>
                    Setelah data pendaftaran berhasil tersimpan, Data Kesehatan Calon Santri tidak bisa di edit, pastikan data sudah sesuai.
                </Alert>
                <Grid sx={{ mt: '20px', padding: '10px' }} container spacing={2}>
                    <Grid sx={{ padding: "5px" }} xs={12} sm={12} md={4} xl={4} lg={4}>
                        <FormLabel sx={{
                            color: "#000000", fontWeight: "bold", marginTop: "15px",
                            "::after": {
                                content: '" *Wajib Diisi"',
                                color: "red",
                                fontWeight: "bold",
                                fontStyle: "italic"
                            }
                        }}>Apakah calon santri mempunyai riwayat penyakit Jantung bawaan?</FormLabel>
                        <RadioGroup data-radioname="riwayat_jantung" data-required="true" name="riwayat_jantung" value={data?.riwayat_jantung} onChange={(e) => { handleChange(e.target.name, e.target.value) }} row>
                            <FormControlLabel value={"Iya"} control={<Radio></Radio>} label="Iya"></FormControlLabel>
                            <FormControlLabel value={"Tidak"} control={<Radio></Radio>} label="Tidak"></FormControlLabel>
                        </RadioGroup>
                    </Grid>
                    <Grid sx={{ padding: "5px" }} xs={12} sm={12} md={4} xl={4} lg={4}>
                        <FormLabel sx={{
                            color: "#000000", fontWeight: "bold", marginTop: "15px",
                            "::after": {
                                content: '" *Wajib Diisi"',
                                color: "red",
                                fontWeight: "bold",
                                fontStyle: "italic"
                            }
                        }}>Apakah calon santri mempunyai riwayat penyakit Gagal Ginjal?</FormLabel>
                        <RadioGroup data-radioname="riwayat_gagal_ginjal" data-required="true" name="riwayat_gagal_ginjal" value={data?.riwayat_gagal_ginjal} onChange={(e) => { handleChange(e.target.name, e.target.value) }} row>
                            <FormControlLabel value={"Iya"} control={<Radio></Radio>} label="Iya"></FormControlLabel>
                            <FormControlLabel value={"Tidak"} control={<Radio></Radio>} label="Tidak"></FormControlLabel>
                        </RadioGroup>
                    </Grid>
                    <Grid sx={{ padding: "5px" }} xs={12} sm={12} md={4} xl={4} lg={4}>
                        <FormLabel sx={{
                            color: "#000000", fontWeight: "bold", marginTop: "15px",
                            "::after": {
                                content: '" *Wajib Diisi"',
                                color: "red",
                                fontWeight: "bold",
                                fontStyle: "italic"
                            }
                        }}>Apakah calon santri mempunyai riwayat penyakit Epilepsi?</FormLabel>
                        <RadioGroup data-radioname="riwayat_epilepsi" data-required="true" name="riwayat_epilepsi" value={data?.riwayat_epilepsi} onChange={(e) => { handleChange(e.target.name, e.target.value) }} row>
                            <FormControlLabel value={1} control={<Radio></Radio>} label="Iya"></FormControlLabel>
                            <FormControlLabel value={0} control={<Radio></Radio>} label="Tidak"></FormControlLabel>
                        </RadioGroup>
                    </Grid>
                    <Grid sx={{ padding: "5px" }} xs={12} sm={12} md={4} xl={4} lg={4}>
                        <FormLabel sx={{
                            color: "#000000", fontWeight: "bold", marginTop: "15px",
                            "::after": {
                                content: '" *Wajib Diisi"',
                                color: "red",
                                fontWeight: "bold",
                                fontStyle: "italic"
                            }
                        }}>Apakah calon santri mempunyai riwayat penyakit HIV/AIDS?</FormLabel>
                        <RadioGroup data-radioname="riwayat_hiv" data-required="true" name="riwayat_hiv" value={data?.riwayat_hiv} onChange={(e) => { handleChange(e.target.name, e.target.value) }} row>
                            <FormControlLabel value={"Iya"} control={<Radio></Radio>} label="Iya"></FormControlLabel>
                            <FormControlLabel value={"Tidak"} control={<Radio></Radio>} label="Tidak"></FormControlLabel>
                        </RadioGroup>
                    </Grid>
                    <Grid sx={{ padding: "5px" }} xs={12} sm={12} md={4} xl={4} lg={4}>
                        <FormLabel sx={{
                            color: "#000000", fontWeight: "bold", marginTop: "15px",
                            "::after": {
                                content: '" *Wajib Diisi"',
                                color: "red",
                                fontWeight: "bold",
                                fontStyle: "italic"
                            }
                        }}>Apakah calon santri mempunyai riwayat penyakit Hepatitis?</FormLabel>
                        <RadioGroup data-radioname="riwayat_hepatitis" data-required="true" name="riwayat_hepatitis" value={data?.riwayat_hepatitis} onChange={(e) => { handleChange(e.target.name, e.target.value) }} row>
                            <FormControlLabel value={"Tidak"} control={<Radio></Radio>} label="Tidak"></FormControlLabel>
                            <FormControlLabel value={"Sembuh"} control={<Radio></Radio>} label="Sembuh"></FormControlLabel>
                            <FormControlLabel value={"Proses Pengobatan"} control={<Radio></Radio>} label="Proses Pengobatan"></FormControlLabel>
                            <FormControlLabel value={"Belum Ada Tindakan"} control={<Radio></Radio>} label="Belum Ada Tindakan"></FormControlLabel>
                        </RadioGroup>
                    </Grid>
                    <Grid sx={{ padding: "5px" }} xs={12} sm={12} md={4} xl={4} lg={4}>
                        <FormLabel sx={{
                            color: "#000000", fontWeight: "bold", marginTop: "15px",
                            "::after": {
                                content: '" *Wajib Diisi"',
                                color: "red",
                                fontWeight: "bold",
                                fontStyle: "italic"
                            }
                        }}>Apakah calon santri mempunyai riwayat penyakit TBC?</FormLabel>
                        <RadioGroup data-radioname="riwayat_tbc" data-required="true" name="riwayat_tbc" value={data?.riwayat_tbc} onChange={(e) => { handleChange(e.target.name, e.target.value) }} row>
                            <FormControlLabel value={"Tidak"} control={<Radio></Radio>} label="Tidak"></FormControlLabel>
                            <FormControlLabel value={"Sembuh"} control={<Radio></Radio>} label="Sembuh"></FormControlLabel>
                            <FormControlLabel value={"Proses Pengobatan"} control={<Radio></Radio>} label="Proses Pengobatan"></FormControlLabel>
                            <FormControlLabel value={"Belum Ada Tindakan"} control={<Radio></Radio>} label="Belum Ada Tindakan"></FormControlLabel>
                        </RadioGroup>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>

    </>);
}
export default DataKesehatan;